export default __webpack_public_path__ + "static/station-f-logo-a3b518993d9f792b4d391755fa49257e.png";